import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';
import { Props } from './types';

type T = Props & AppStyledProps;

export const ListStyled = styled.ul<T>`
  max-height: 80vh;
  overflow-y: auto;
  font-size: 1em;
  width: 200px;

  .chapter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1em;
    width: 100%;
    color: #fff;
    position: relative;
    cursor: pointer;
    padding: 0.5em 1.25em;
    overflow-wrap: anywhere;

    &.active {
      background-color: #2055ff;
      ${({ buttonColor }) => buttonColor && `background-color: ${buttonColor};`}
    }

    &:hover {
      background-color: #2055ff;
      ${({ buttonColor }) => buttonColor && `background-color: ${buttonColor};`}
      opacity: 0.7;
    }

    &.locked {
      cursor: none;
      pointer-events: none;
      opacity: 0.7;
    }

    ${({ color }) => color && `color: ${color};`}
  }

  ${({ theme }) =>
    theme.device.mobile &&
    `
  `}
`;
